import { Options } from "../interface";

/** SVGPathCommander default options */
const defaultOptions: Options = {
  origin: [0, 0, 0],
  round: 4,
};

export default defaultOptions;
